"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeObjectDepartment = void 0;
var tslib_1 = require("tslib");
var base_1 = require("./base");
var IkeObjectDepartment = /** @class */ (function (_super) {
    tslib_1.__extends(IkeObjectDepartment, _super);
    function IkeObjectDepartment() {
        var _this = _super.apply(this, tslib_1.__spreadArray([], tslib_1.__read(arguments), false)) || this;
        _this.className = 'Department';
        _this.actionName = 'department';
        return _this;
    }
    return IkeObjectDepartment;
}(base_1.IkeRestObject));
exports.IkeObjectDepartment = IkeObjectDepartment;
//# sourceMappingURL=department.object.js.map